//3rd Party Components
import React, { Fragment } from 'react';
import AUpageAlert from '@gov.au/page-alerts';
import { useSelector } from "react-redux";
import MetaTags from 'react-meta-tags';

//Actions
import { getUrlSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getPortalUrl } from '../components/Portal/Utilities';
import { urlSearchValue } from '../components/Portal/Utilities';

export const ErrorPage = () => {
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    const loc = getPortalUrl("/", standalone, urlHome); 

    let msg = urlSearchValue("code");

    return (
        <Fragment>
            <MetaTags>
                <title>Error</title>
            </MetaTags>

            <AUpageAlert as="error">
                <div id="systemError" aria-live="polite">
                    <br />
                    <h3>We&apos;re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.</h3>
                    <h4>Details: System error ({msg})</h4>
                    <br />
                </div>
            </AUpageAlert>

            <div>
                <button className="btn-link au-direction-link au-direction-link--left" href={loc}>Return to myCASA</button>
            </div>

        </Fragment>

    );
    
}

